import { Component, inject, signal, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthPermissionService } from '../../../../modules/auth/application/services/auth-permission.service';
import { AppPermission } from '../../../../modules/auth/domain/enums/app-permission.enum';
import { environment } from '../../../../../environments/environment';

interface HelpOption {
  label: string;
  fileName: string;
}

@Component({
  selector: 'app-help-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-button.component.html',
  styleUrl: './help-button.component.scss',
})
export class HelpButtonComponent {
  private readonly permissionService = inject(AuthPermissionService);

  protected readonly isHovered = signal(false);
  protected readonly isOpen = signal(false);

  protected readonly isClient = this.permissionService.hasAnyPermission([AppPermission.QualityControlByClient]);

  private readonly baseUrl = environment.apiUrl;

  protected readonly allOptions: HelpOption[] = [
    { label: 'Guía rápida Cliente', fileName: environment.userGuides.quickGuide },
    { label: 'Manual Usuario Cliente', fileName: environment.userGuides.clientManual },
    { label: 'Manual Usuario Proveedor', fileName: environment.userGuides.providerManual },
  ];

  protected get options(): HelpOption[] {
    return this.allOptions.filter(o =>
      o.fileName !== environment.userGuides.providerManual || !this.isClient
    );
  }

  protected toggleMenu(): void {
    this.isOpen.update(v => !v);
  }

  protected download(option: HelpOption): void {
    const link = document.createElement('a');
    link.href = `${this.baseUrl}/${option.fileName}`;
    link.target = '_blank';
    link.click();
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.help-btn-wrapper')) {
      this.isOpen.set(false);
    }
  }
}
